import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../../modifiersState/modifiersContext';
import classNames from 'classnames';
import Item from './components/Item';
import style from './List.module.scss';

const List: React.FC = () => {
	const { modifiers } = useContext<IModifiersContext>(ModifiersContext);

	const modifierHeadingClasses = classNames(style.modifier, style.heading);
	const articleHeadingClasses = classNames(style.article, style.heading);
	const restaurantHeadingClasses = classNames(style.restaurant, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const isDisabledHeadingClasses = classNames(style.isDisabled, style.heading);
	const isRestrictedHeadingClasses = classNames(style.isRestricted, style.heading);
	const isPreselectedHeadingClasses = classNames(style.isPreselected, style.heading);
	const priceHeadingClasses = classNames(style.price, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="List">
			<div className={style.tableHeaders}>
				<Text
					className={modifierHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameOfModifierLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={articleHeadingClasses}
					translationNameSpace="listing"
					translationKey="articleNumberLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={restaurantHeadingClasses}
					translationNameSpace="listing"
					translationKey="restaurantLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={customerHeadingClasses}
					translationNameSpace="listing"
					translationKey="customerLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isDisabledHeadingClasses}
					translationNameSpace="listing"
					translationKey="inStopLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isRestrictedHeadingClasses}
					translationNameSpace="listing"
					translationKey="isRestrictedLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={isPreselectedHeadingClasses}
					translationNameSpace="listing"
					translationKey="preselectedModifiersLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={priceHeadingClasses}
					translationNameSpace="listing"
					translationKey="priceLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					theme="neutralLight"
					withTooltip={true}
				/>
			</div>
			{modifiers.modifiers.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};

export default List;
